/* src/app/dialogs/division-editor/division-editor.component.css */
/*# sourceMappingURL=division-editor.component-XZHOCMCH.css.map */
